module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/mobile-phones@2x.b85619f.png";